var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"50px","text-align":"center"}},[_c('h1',[_vm._v("404 Not Found")]),_c('p',[_vm._v("访问页面不存在..."),_c('router-link',{attrs:{"to":"/"}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }